import React, { useEffect, useState } from 'react';
import {
  LinkTo,
  Col,
  Grid,
  CheckboxContainer,
  CHECKBOX_STATES,
} from '@common/components';

import { useAppDispatch, useAppSelector } from '@app/hooks';
import { DashboardSection, LayoutFilters } from '@dashboard/components';
import { useDeleteMutation, useGetAllUsersQuery } from '@dashboard/api/users';
import { useTranslation } from 'react-i18next';
import NotResults from '@dashboard/components/NotResults/NotResults';
import { selectUsers, setUsers } from '@dashboard/slices/users';
import UserCard from '@dashboard/components/UserCard/UserCard';
import { AlertModal } from '@app/components';
import viewClasess from './UserListView.module.scss';

export default function UserListView() {
  const dispatch = useAppDispatch();
  const userState = useAppSelector(selectUsers);
  const { t } = useTranslation('dashboard\\UserListView');
  const [selectedItemToDelete, setSelectedItemToDelete] = useState(undefined);
  const [deleteUser] = useDeleteMutation();
  const [showInactive, setShowInactive] = useState(false);

  const { data, isLoading, refetch } = useGetAllUsersQuery({
    refetchOnFocus: true,
  });

  const showDelete = (uuid) => {
    setSelectedItemToDelete(uuid);
  };

  const onAcceptDelete = async () => {
    await deleteUser(selectedItemToDelete);
    setSelectedItemToDelete(undefined);
    refetch();
  };

  const onCancelDelete = () => {
    setSelectedItemToDelete(undefined);
  };

  useEffect(() => {
    refetch();
  }, []);

  useEffect(() => {
    dispatch(setUsers(data && data.data ? data.data : []));
  }, [data]);

  return (
    <LayoutFilters>
      <section className={viewClasess.dashboard}>
        <DashboardSection title={t('userListTitle')}>
          <div className={viewClasess.buttonContainer}>
            <CheckboxContainer
              id="showInactive"
              value="showInactive"
              label={t('showInactive')}
              onChange={(event) => {
                setShowInactive(event.target.checked);
              }}
              checked={
                showInactive
                  ? CHECKBOX_STATES.Checked
                  : CHECKBOX_STATES.Indeterminate
              }
            />
            <LinkTo
              button
              href="/dashboard/users/create"
              variant="raised"
              color="accent"
            >
              {t('labelAdd')}
            </LinkTo>
          </div>
        </DashboardSection>

        {!isLoading ? (
          <Grid>
            <Col xss={12} xs={12} sm={12}>
              {userState && userState.users && userState.users.length ? (
                userState.users
                  .filter((user) =>
                    showInactive ? true : user.active === true,
                  )
                  .map((user) => (
                    <UserCard
                      key={user.uuid}
                      user={user}
                      onDelete={() => showDelete(user.uuid)}
                    />
                  ))
              ) : (
                <NotResults isLoading={isLoading} card />
              )}
            </Col>
          </Grid>
        ) : (
          <NotResults isLoading={isLoading} card />
        )}
      </section>
      <AlertModal
        type="question"
        show={selectedItemToDelete !== undefined}
        title={t('deleteTitle')}
        text={t('deleteText')}
        onAccept={onAcceptDelete}
        onCancel={onCancelDelete}
        onClose={onCancelDelete}
      />
    </LayoutFilters>
  );
}

UserListView.propTypes = {};
